import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { CursoService } from '../../api/services';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-cadastrar-curso',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    Select,
    InputTextModule,
    ButtonModule,
    ToastModule,
  ],
  providers:[MessageService],
  templateUrl: './cadastrar-curso.component.html',
  styleUrl: './cadastrar-curso.component.scss',
  standalone: true,
})
export class CadastrarCursoComponent implements OnInit {
  cursoForm!: FormGroup;
  areaFormacaoList: any[] = [];
  categoriaInstituicaoEnsinoList: any[] = [];
  nivelAcademicoOptions: any[] = [];

  private fb = inject(FormBuilder);
  private cursoService = inject(CursoService);
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  messageService = inject(MessageService);


  constructor() {
    this.cursoForm = this.fb.group({
      id: [0],
      designacao: ['', Validators.required],
      sigla: ['S'],
      areaFormacaoID: [null, Validators.required],
      nivelAcademico: [null, Validators.required],
      codigo: ['1'],
      categoriaInstituicaoEnsinoID: [null, Validators.required],
    });

    const data = this.config.data;
    if (data) {
      this.areaFormacaoList = data.areaFormacaoList || [];
      this.categoriaInstituicaoEnsinoList =
        data.categoriaInstituicaoEnsinoList || [];
      this.nivelAcademicoOptions = data.nivelAcademicoOptions || [];
    }
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.config.data && this.config.data.cursoDetails) {
      this.loadCursoDetails(this.config.data.cursoDetails);
    }
  }

  save() {
    if (this.cursoForm.valid) {
      const curso = this.cursoForm.value;
      this.ref.close(curso); // Close the dialog and pass the form data
    } else {
      this.cursoForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
      console.log('Formulário inválido:', this.cursoForm.getRawValue());
    }
  }

  loadCursoDetails(cursoDetails: any) {
    this.cursoForm.patchValue({
      ...cursoDetails,
      id: cursoDetails.id,
      designacao: cursoDetails.designacao,
      sigla: cursoDetails.sigla,
      areaFormacaoID: cursoDetails.areaFormacaoId || cursoDetails.areaFormacaoID,
      nivelAcademico:
        cursoDetails.nivelAcademicoValueEnum || cursoDetails.nivelAcademico,
      codigo: cursoDetails.codigo,
      categoriaInstituicaoEnsinoID:
        cursoDetails.categoriaId || cursoDetails.categoriaInstituicaoEnsinoID,
    });
  }

  cancel() {
    this.ref.close(); // Close the dialog without saving
  }
}
